import { configureStore } from '@reduxjs/toolkit';

import sentryReduxEnhancer from 'monitoring/reduxEnhancer';
import { getEnv } from 'utils/utils';
import listenerMiddleware from './middleware/listenerMiddleware';
import specialtiesSlice from './slices/specialties/specialtiesSlice';
import promotionsSlice from './slices/promotions/promotionsSlice';
import filtersSlice from './slices/filters/filtersSlice';
import mapSlice from './slices/map/mapSlice';
import locationSlice from './slices/location/locationSlice';
import uiSlice from './slices/ui/uiSlice';
import resultsSlice from './slices/results/resultsSlice';
import searchSlice from './slices/search/searchSlice';
import configSlice from './slices/config/configSlice';
import tooltipSlice from './slices/tooltip/tooltipSlice';
import notificationsSlice from './slices/notifications/notificationsSlice';
import servicesSlice from './slices/services/servicesSlice';
import chatSlice from './slices/chat/chatSlice';
import bannerSlice from './slices/banner/bannerSlice';
import rewardsSlice from './slices/rewards/rewardsSlice';
import costSlice from './slices/cost/costSlice';
import aiSearch from './slices/aiSearch/aiSearchSlice';
import referringClinic from './slices/referringClinic/referringClinicSlice';
import sessionSlice from './slices/session/sessionSlice';

import analyticsMiddleware from '../analytics/analyticsMiddleware';
import fusionApi from './query/fusion/fusionApi';
import atlasApi from './query/atlas/atlasApi';

const store = configureStore({
  reducer: {
    [specialtiesSlice.name]: specialtiesSlice.reducer,
    [tooltipSlice.name]: tooltipSlice.reducer,
    [promotionsSlice.name]: promotionsSlice.reducer,
    [filtersSlice.name]: filtersSlice.reducer,
    [mapSlice.name]: mapSlice.reducer,
    [locationSlice.name]: locationSlice.reducer,
    [uiSlice.name]: uiSlice.reducer,
    [resultsSlice.name]: resultsSlice.reducer,
    [searchSlice.name]: searchSlice.reducer,
    [configSlice.name]: configSlice.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [servicesSlice.name]: servicesSlice.reducer,
    [chatSlice.name]: chatSlice.reducer,
    [bannerSlice.name]: bannerSlice.reducer,
    [rewardsSlice.name]: rewardsSlice.reducer,
    [costSlice.name]: costSlice.reducer,
    [aiSearch.name]: aiSearch.reducer,
    [referringClinic.name]: referringClinic.reducer,
    [sessionSlice.name]: sessionSlice.reducer,
    // RTK Query
    [fusionApi.reducerPath]: fusionApi.reducer,
    [atlasApi.reducerPath]: atlasApi.reducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    fusionApi.middleware,
    atlasApi.middleware,
    listenerMiddleware.middleware,
    analyticsMiddleware,
  ],
  enhancers: (defaultEnhancers) => [...defaultEnhancers, sentryReduxEnhancer],
  devTools: getEnv() !== 'production',
});

export default store;
